export { PinsListItem } from './PinsListItem.component';
